module.exports = validateSheetLocations
const { parseAllocationSheet } = require('./utils/make-bulk-snapshot-from-sheet')
const { getByIds } = require('../location/api/read/get-by-ids')
const set = require('lodash/set')
const get = require('lodash/get')

async function validateSheetLocations (state, buffer, { isCnR = false } = {}) {
  const rows = parseAllocationSheet(buffer, { isCnR })
  let allHavePackPointLevel
  let locationRoutes = {}
  const today = new Date().toJSON()
  const uniqueIdsSet = new Set(rows.map(r => r.id))
  const uniqueIds = Array.from(uniqueIdsSet)

  const uniqueSupplierIdsSet = new Set(rows.map(r => r.supplier))
  const uniqueSupplierIds = Array.from(uniqueSupplierIdsSet)

  const allLocations = [...uniqueIds, ...uniqueSupplierIds]

  try {
    const locations = await getByIds(state, allLocations, today)

    const { suppliers, routesByLocationId } = locations.reduce((acc, location) => {
      // In cases of CNR the packpoints are in the supplier column
      // But in regualr returns the packpoints are in the id column
      // In both cases we want to make sure they are all pack points
      // This would still work for pack point to point shipments
      // But fail on pack point to pharmacy shipments
      if (isCnR) {
        if (uniqueSupplierIds.includes(location._id)) {
          acc.suppliers.push(location)
        }
      } else {
        if (uniqueIds.includes(location._id)) {
          acc.suppliers.push(location)
        }
      }
      const routeId = get(location, 'joinedDocs.currentRoute._id')
      const parsedRoute = typeof routeId === 'string' ? routeId.replace('funder:', 'route:') : routeId
      set(acc.routesByLocationId, location._id, parsedRoute)
      return acc
    }, {
      suppliers: [],
      routesByLocationId: {}
    })
    locationRoutes = routesByLocationId

    if (locations.length !== allLocations.length) {
      const missingIds = uniqueIds.filter(id => !locations.some(location => location && location._id === id))
      console.error('Missing locations for IDs:', missingIds)
      allHavePackPointLevel = false
    } else {
      allHavePackPointLevel = suppliers.every(location => location.level !== 'sdp')
    }
  } catch (error) {
    console.error('Error fetching location data:', error)
    return false
  }

  return { validLocations: allHavePackPointLevel, locationRoutes }
}
